var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('Sidebar',{staticClass:"sidebar-container"}),_c('div',{staticClass:"main-container"},[_c('Navbar'),_c('AppMain')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }